import { ModelType } from '../types/models';
import { VehiclesBackgroundType, VehiclesFontType } from '../types/vehicles';

const DARKCOLOR = '#000000';
const LIGHTCOLOR = '#FFFFFF';

export const vehiclesBackground : VehiclesBackgroundType<ModelType> = {
    golf: '#DFE4E8',
    golfgti: '#91969D',
    passat: '#161616',
    passattsi: '#161616',
    egolf: '#EDEDED',
    golfr: '#0E1342',
    jettatsi: '#193868',
    jettagli: '#A41716',
    tiguan: '#BD3319',
    golfalltrack: '#A41716',
    golfsportwagen: '#474A51',
    atlas: '#51000C',
    arteon: '#A48100',
    beetletsi: '#DFD7C1',
    beetle: '#DFD7C1',
    beetleconvertible: '#DFE4E8',
    jetta : '#193868',
    golfwagon : '#474A51',
    golftdiwagon : '#474A51',
    golftdi : '#DFE4E8',
    passattdi : '#161616',
    golfsportwagentdi : '#474A51',
    atlascrosssport : '#474A51',
    newbeetle : '#DFD7C1',
    eos : '#DFE4E8',
    eosconvertible : '#DFE4E8',
    rabbit : '#161616',
    jettatsisedan :' #193868',
    jettasedan : '#193868',
    jettatdi : '#193868',
    jettasportwagentdi : '#193868',
    jettasportwagen : '#193868',
    newbeetleconvertible : '#DFE4E8',
    jettaglisedan : '#A41716',
    jettahybrid : '#193868',
    passatsedantsi : '#161616',
    passatwagontsi : '#161616',
    passatwagen : '#0e1342',
    passatcctsi : '#030303',
    passatcc : '#EDEDED',
    cc : '#EDEDED',
    beetletdi :' #DFD7C1',
    beetleconvertibletsi : '#DFE4E8',
    tiguantsi : '#BD3319',
    routan: '#7FA9B8',
    touaregtdi : '#0E1342',
    touareg : '#0E1342',
    golfcity : '#DFE4E8',
    jettacity : '#193868',
    egolfhb : '#EDEDED',
    taos: '#3B454F',
    id4: '#1E335F',
    idbuzz: '#474A51',
} 

export const vehiclesFont : VehiclesFontType<ModelType> = {
    golf: DARKCOLOR,
    golfgti: DARKCOLOR,
    passat: LIGHTCOLOR,
    passattsi: LIGHTCOLOR,
    egolf: DARKCOLOR,
    golfr: LIGHTCOLOR,
    jettatsi: LIGHTCOLOR,
    jettagli: LIGHTCOLOR,
    tiguan: LIGHTCOLOR,
    golfalltrack: LIGHTCOLOR,
    golfsportwagen: LIGHTCOLOR,
    atlas: LIGHTCOLOR,
    arteon: DARKCOLOR,
    beetletsi: DARKCOLOR,
    beetle: DARKCOLOR,
    beetleconvertible: DARKCOLOR,
    golfwagon : LIGHTCOLOR,
    golftdiwagon : LIGHTCOLOR,
    golftdi : DARKCOLOR,
    passattdi : LIGHTCOLOR,
    golfsportwagentdi : LIGHTCOLOR,
    atlascrosssport : LIGHTCOLOR,
    newbeetle : DARKCOLOR,
    rabbit : LIGHTCOLOR,
    jettatsisedan : LIGHTCOLOR,
    jettasedan : LIGHTCOLOR,
    jettatdi : LIGHTCOLOR,
    jettasportwagentdi : LIGHTCOLOR,
    jettasportwagen : LIGHTCOLOR,
    newbeetleconvertible : DARKCOLOR,
    jettaglisedan : LIGHTCOLOR,
    jettahybrid : LIGHTCOLOR,
    passatsedantsi : LIGHTCOLOR,
    passatwagontsi : LIGHTCOLOR,
    passatwagen : LIGHTCOLOR,
    beetletdi : DARKCOLOR,
    beetleconvertibletsi : DARKCOLOR,
    tiguantsi : LIGHTCOLOR,
    routan: DARKCOLOR,
    touaregtdi : LIGHTCOLOR,
    touareg : LIGHTCOLOR,
    golfcity : DARKCOLOR,
    jettacity : LIGHTCOLOR,
    egolfhb : DARKCOLOR,
    jetta : LIGHTCOLOR,
    taos: LIGHTCOLOR,
    id4: LIGHTCOLOR,
    passatcc: DARKCOLOR,
    eos: DARKCOLOR,
    idbuzz: LIGHTCOLOR
}